<if-page-view [millisecondInterval]="1500" ifQueryControl="ld">
  <if-page-view-slide>
    <div class="slide_wrap">
      <div class="content">
        <p>
          {{"Checking if you qualify for special offers..." | trans: "loader-slide1"}}
        </p>
        <div class="progress-bar_wrap">
          <span class="progress-bar"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>

  <if-page-view-slide>
    <div class="slide_wrap">
      <div class="content">
        <p>{{ "Congratulations, you are qualified!" | trans: "loader-slide2" }}</p>
        <div class="progress-bar_wrap">
          <span class="progress-bar progress-step1"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>

  <if-page-view-slide>
    <div class="slide_wrap">
      <div class="content">
        <p>{{ "Checking for stock..." | trans: "loader-slide3" }}</p>
        <div class="progress-bar_wrap">
          <span class="progress-bar progress-step2"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>

  <if-page-view-slide>
    <div class="slide_wrap">
      <div class="content">
        <p>{{ "Stock available!" | trans: "loader-slide4" }}</p>
        <div class="progress-bar_wrap">
          <span class="progress-bar progress-step3"></span>
        </div>
      </div>
    </div>
  </if-page-view-slide>
  <!-- Empty slide for timing -->
  <if-page-view-slide></if-page-view-slide>
  <!-- /Empty slide for timing -->
</if-page-view>
<if-billing-form #form [defaultSelectedVariant]="0">
  <div id="wrapper" *ngIf="form.product" class="{{'' | trans: 'lang'}}">
    <header>
      <div class="row header-top">
        <div class="container">
          <h5>{{"Your 50% OFF discount has been applied!" | trans: "discount50applied"}}</h5>
        </div>
      </div>
      <div class="container">
        <div class="main-banner">
          <figure class="logo">
            <if-async-image
              [src]="form.getImageSrcByName('logo')"
              id="prod-logo"
            ></if-async-image>
          </figure>
          <figure class="top-banner">
            <if-async-image
              *ngIf="form.getImageSrcByName('banner-boxes-3')"
              [src]="form.getImageSrcByName('banner-boxes-3')"
            ></if-async-image>
          </figure>
        </div>

        <ul class="breadcrumbs">
          <li>{{"Checkout" | trans: "breadcrumbs1"}}</li>
          <li>{{"Bonuses" | trans: "breadcrumbs2"}}</li>
          <li>{{"Order receipt" | trans: "breadcrumbs3"}}</li>
        </ul>
      </div>
    </header>
    <div class="container" #targetEdit>
      <div class="bundle-title">
        <h4>{{"Select Quantity" | trans: "bundleQty"}}</h4>
      </div>
      <if-billing-form-product-variant-select [form]="form" class="bundle_wrap" id="bundle_wrap">
        <ng-template #packageCountryTemplate let-packageCountry="packageCountry" let-isSelected="isSelected">
          <label class="prod-item" [class.selected]="isSelected" *ngIf="form.product" class="{{packageCountry.packageData.bestSeller ? 'featured' : ''}}">
            <div class="prod-header">
              <div class="stars"></div>
              <p class="productDescription">
                <strong>{{packageCountry.title}}</strong> - <span class="no-wrap">{{100 - ((packageCountry.price / packageCountry.originalPrice) * 100) | number: "1.0-0"}}% {{"Off" | trans: "off"}}</span>
              </p>
            </div>
            <div class="content">
              <div class="units">{{packageCountry.packageData.units}}x</div>
              <div class="box-inner">
                <h5 class="productName">
                  {{form.product.productData.title}}
                </h5>
                <div class="prod-image_wrap hide-mobile">
                  <figure class="prod-image" *ngFor="let item of [].constructor(packageCountry.packageData.units);
                      let i = index">
                    <if-async-image [src]="form.getImageSrcByName('product-image')"></if-async-image>
                    <span class="amount">{{packageCountry.packageData.units}}</span>
                  </figure>
                </div>
                <div class="price_wrap">
                  <p>
                    <span class="price-total">
                      {{"Total" | trans: "total"}}:
                      {{form.currency}}{{packageCountry.price}}
                    </span>
                    <span class="price-org delete">{{form.currency}}{{packageCountry.originalPrice}}</span>
                  </p>
                  <p>
                    <span class="price-each">{{form.currency}}{{((packageCountry.price) / (packageCountry.packageData.units)).toFixed(2)}}</span>
                    {{"each" | trans: "each"}}
                  </p>
                </div>
              </div>
              <div class="prod-image_wrap hide-desktop">
                <figure class="prod-image" *ngFor="let item of [].constructor(packageCountry.packageData.units);
                    let i = index">
                  <if-async-image [src]="form.getImageSrcByName('product-image')"></if-async-image>
                  <span class="amount">{{packageCountry.packageData.units}}</span>
                </figure>
              </div>
            </div>
            <div class="button_wrap">
              <button type="button" class="button">
                <span (click)="scroll(targetForm)">
                  {{"Order now" | trans: "orderBtn"}}
                </span>
              </button>
            </div>
          </label>
        </ng-template>
      </if-billing-form-product-variant-select>

      <div class="cols_wrap">
        <div class="col col-form" #targetForm>
          <div class="variants_wrap">
            <if-variant-select *ngIf="form.product" [form]="form" error="{{'Out of stock' | trans: 'oOStock'}}" itemSelectString="{{'Item' | trans: 'item'}}">
              <ng-template #attributeNameTemplate let-attribute="attribute">
                <h6 class="variant-title">{{attribute}}</h6>
              </ng-template>
              <ng-template #optionTemplate let-option="option">{{option}}</ng-template>
              <ng-template #priceDiffTemplate let-priceDiff="priceDiff">
                <h6 class="variant-price">{{"Extra:" | trans: "extra"}}{{form.currency}}{{priceDiff}}</h6>
              </ng-template>
              <ng-template #errorTemplate let-error="error">
                <h6 class="variant-error">{{error}}</h6>
              </ng-template>
            </if-variant-select>
          </div>

          <div class="sum_wrap hide-desktop">
            <div class="sum-header">
              <h5 class="title">{{"Order summary" | trans: "summaryTitle"}}</h5>
            </div>
            <div class="order-item">
              <figure class="prod-image"><if-async-image [src]="form.getImageSrcByName('product-image')"></if-async-image></figure>
              <div class="sum-text">
                <div class="text">
                  <h6 class="productName">{{form.selectedPackageTitle}}</h6>
                  <h6 class="edit-link" (click)="scroll(targetEdit)">{{"Edit" | trans: "edit"}}</h6>
                </div>
                <div class="sum-price">
                  <h6 class="sum-qty">{{"QTY" | trans: "qty"}}: <span class="amount">{{ form.selectedPackageCountry.packageData.units }}</span></h6>
                  <h6 class="sum-price">{{form.currency}}{{form.cartPrice}}</h6>
                </div>
              </div>
            </div>
            <ul class="order-list">
              <li class="order-list-item">
                <span class="list-desc">{{"Subtotal" | trans: "subTotal"}}</span>
                <span class="list-price">{{form.currency}}{{form.cartPrice}}</span>
              </li>
              <li class="order-list-item">
                <span class="list-desc">{{"Discount" | trans: "discount"}}</span>
                <span class="list-price discount-text">-{{form.currency}}{{form.discount}}</span>
              </li>
              <li class="order-list-item" *ngIf="form.variantsAdditionalPrice && form.variantsAdditionalPrice != 0 ">
                <span class="list-desc">{{"Additional cost" | trans: "additionalCost"}}</span>
                <span class="list-price">{{form.currency}}{{form.variantsAdditionalPrice}}</span>
              </li>
              <li class="order-list-item" *ngIf="form.bumpCheckbox">
                  <span class="list-desc">{{ form.selectedPackageCountry.bumpPackageCountry.packageData.units}} {{ form.selectedPackageCountry.bumpPackageCountry.packageData.productName }}</span>
                  <span class="list-price">{{ form.currency }}{{ form.selectedPackageCountry.bumpPackageCountry.price }}</span>
              </li>
              <li class="order-list-item" *ngIf="form.formGroup.value.warranty">
                <span class="list-desc">{{"Lifetime Protection" | trans: "warrantyLine"}}</span>
                <span class="list-price">{{form.currency}}{{form.warrantyPrice}}</span>
              </li>
              <li class="order-list-item mark">
                <span class="list-desc">{{"Shipping" | trans: "shipping"}}</span>
                <span class="list-price">{{form.currency}}{{form.shippingPrice}}</span>
              </li>
              <li class="order-list-item">
                <span class="list-desc">{{"Total" | trans: "total"}}</span>
                <span class="list-price">{{form.currency}}{{form.totalPrice}}</span>
              </li>
            </ul>
          </div>

          <h5 class="form-title">{{"Personal details" | trans: "titleDetails"}}</h5>
          <div class="form">


            <if-billing-form-radio
              [form]="form"
              name="gender"
              [required]="true"
              default="male"
            >
            <ng-template
            #selectOptions
            let-select="select"
            let-selectedValue="selectedValue">
            <div class="options_wrap">
              <div class="option" (click)="select('male')">
                <input type="radio" name="gender" checked>
                <p>{{ "Male" | trans: "male" }}</p>
                <!-- <div *ngIf="selectedValue() == 'male'" class="selected">male</div>
                <div *ngIf="selectedValue() !== 'male'">male</div> -->
              </div>
              <div class="option" (click)="select('female')">
                <input type="radio" name="gender">
                <p>{{ "Female" | trans: "female" }}</p>
              </div>
              <div class="option" (click)="select('other')">
                <input type="radio" name="gender">
                <p>{{ "Other" | trans: "other" }}</p>
              </div>
            </div>
          </ng-template>
            </if-billing-form-radio>



            <if-billing-form-input [form]="form" label="{{'Full Name' | trans: 'fullName'}}" name="fullName" type="text" [required]="true" autocomplete="off" error="{{'Enter a full name' | trans: 'fullNameError'}}">
            </if-billing-form-input>

            <if-billing-form-input [form]="form" label="{{'Email Address' | trans: 'email'}}" name="email" type="email" [required]="true" autocomplete="off" error="{{'Enter a valid email' | trans: 'emailError'}}">
            </if-billing-form-input>

            <if-billing-form-mobile-flag-input
              [form]="form"
              placeholder="{{ 'Phone number' | trans: 'phone' }}"
              error="{{'Enter a valid phone number' | trans: 'phoneError'}}"
            >

              <ng-template #labelTemplate let-option="option">
                <if-async-image
                  *ngIf="option.code2"
                  [src]="
                    '../assets/flags/' + option.code2.toLowerCase() + '.svg'
                  "
                ></if-async-image>
                <span>+ {{ option.number }}</span>
              </ng-template>
              <ng-template #optionTemplate let-option="option">

                <div class="countries">
                  <span class="flags">
                    <if-async-image
                      [src]="
                        '../assets/flags/' +
                        option.code2.toLowerCase() +
                        '.svg'
                      "
                    ></if-async-image>
                  </span>
                  <span class="country-name"
                    >{{ option.name }} +{{ option.number }}</span
                  >
                </div>
              </ng-template>
            </if-billing-form-mobile-flag-input>

          </div>

          <h5 class="form-title">{{"Shipping address" | trans: "titleShipping"}}</h5>
          <div class="form">
            <!-- embed details -->
            <div id="full-details-form">
              <if-billing-form-input
                [form]="form"
                label="{{ 'Street'  }}"
                name="street"
                type="text"
                [required]="true"
                autocomplete="off"
                error="{{
                  'Enter a delivery street'
                }}"
                >
                </if-billing-form-input>

                <if-billing-form-input
                [form]="form"
                label="{{ 'Street Number'  }}"
                name="streetNumber"
                type="text"
                [required]="true"
                autocomplete="off"
                error="{{
                  'Enter a delivery street number'
                }}"
                >
                </if-billing-form-input>

              <if-billing-form-input [form]="form" label="{{'City' | trans: 'city'}}" name="city" type="text" [required]="true" autocomplete="off" error="{{'Enter a valid city name' | trans: 'cityError'}}"></if-billing-form-input>

              <if-billing-form-country-select
                [form]="form" name="country" label="Country" placeholder="{{'Country' | trans: 'country'}}" [required]="true">
              </if-billing-form-country-select>

              <if-billing-form-state-select [form]="form" name="state" placeholder="{{'State/Province' | trans: 'state'}}" [required]="false" error="Select state">
              </if-billing-form-state-select>

              <if-billing-form-input [form]="form" label="{{'Zip code' | trans: 'zipCode'}}" name="zip" type="text" [required]="true" autocomplete="off" error="{{'Enter a valid zip code' | trans: 'zipCodeError'}}" >
              </if-billing-form-input>
            </div>
            <!-- /embed details -->
          </div>

          <h5 class="form-title" ifQueryControl="apg" showWhen="0">{{"Choose payment method" | trans: "chooosePaymentMethod"}}</h5>
          <h5 class="form-title" ifQueryControl="apg" showWhen="1">{{"Payment method" | trans: "paymentMethod"}}</h5>



			 <div class="order-bump_wrap" *ngIf="!form.selectedPackageCountry.bumpPackageCountry">
               <if-billing-form-checkbox [form]="form" name="warranty" error="Please confirm" [required]="false">
                 <p class="checkbox-text">
                   {{"Yes, I Want Lifetime Protection" | trans: "warrantyTitle"}}
                 </p>
               </if-billing-form-checkbox>
               <div class="offer">
                 <p *ngIf="form.product">
                   {{"One Time Offer: By placing your order today, you can have a lifetime protection and replacement warranty for only an additional " | trans: "warrantyText1"}}
                   <span class="war-amount">{{form.currency}}{{form.warrantyPrice}}</span>.
                   {{"This extended warranty means your product is covered for LIFE." | trans: "warrantyText2"}}
                 </p>
               </div>
             </div>


            <div class="order-bump_wrap" *ngIf="form.selectedPackageCountry.bumpPackageCountry">
              <if-billing-form-checkbox [form]="form" name="bumpCheckbox" error="Please confirm" [required]="false">
                <p class="checkbox-text">
                  {{ form.selectedPackageCountry.bumpPackageCountry.bumpTitle }}
                </p>
              </if-billing-form-checkbox>
              <div class="offer">
                <p [innerHTML]="form.selectedPackageCountry.bumpPackageCountry.bumpContent">
                </p>
              </div>
            </div>

   		<div>
<if-select-payment-method [form]="form">
              <ng-template
                #choosePaymentMethodButtonTemplate
                let-select="select"
                let-back="back">
                <div (click)="select()" class="select-payment-btn">
                  Choose payment Method
                </div>
              </ng-template>

              <ng-template
                #selectPaymentMethodTemplate
                let-select="select"
                let-back="back"
                let-paymentMethods="paymentMethods">
                <div id="overlay"></div>
                <div class="modal payment-modal">
                  <div (click)="back()" class="close-modal"></div>
                  <div (click)="select('CREDITCARD')" class="method-button">
                    <div class="radio-button"></div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/payment-icons2.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div (click)="select('PAYPAL')" class="method-button">
                    <div class="radio-button"></div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/paypal.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div *ngIf="paymentMethods.includes('ideal')" (click)="select('IDEAL')" class="method-button ideal">
                    <div class="radio-button"></div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/ideal.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div *ngIf="paymentMethods.includes('klarna')" (click)="select('KLARNA')" class="method-button">
                    <div class="radio-button"></div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/klarna.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                </div>
              </ng-template>

              <ng-template #creditCardFormDialogTemplate let-submit="submit" let-back="back">
                <div id="overlay"></div>
                <div class="modal payment-modal">
                  <div class="modal-header">
                    <div (click)="back()" class="back">
                      <!-- back -->
                      <i class="material-icons">arrow_back</i>
                    </div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/payment-icons2.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div class="form">
                    <div id="payment-form">
                      <div class="if-billing-form">
                        <if-billing-form-input
                          class="cc-input"
                          [form]="form"
                          type="text"
                          [maxlength]="16"
                          [minlength]="14"
                          name="cardNumber"
                          error="{{'Please, enter valid card number'}}" [required]="true"
                          label="{{ 'Credit card number'  }}">
                          <i class="material-icons" prefix>lock</i>
                          <div class="cc-image {{ form.creditCardType }}" [ngStyle]="{'background-image':'url(assets/images/cards/card-' +(form.creditCardType || 'blank') + '.jpg)'}" postfix></div>
                        </if-billing-form-input>
                        <if-billing-form-input
                          [form]="form"
                          type="text"
                          [maxlength]="4"
                          name="cvvCode"
                          [required]="true"
                          autocomplete="off"
                          label="{{ 'CVV code'  }}"
                          error="{{'Please, enter a valid cvv code'}}">
                          <span class="cvv-info" postfix>
                            <span class="cvv-icon">?</span>
                            <div class="cvv-exp">
                              <div class="container">
                                <p>
                                  {{
                                  "The security code is a three digit number, located on the back of any Visa ® or MasterCard ® on the right side of the signature strip as illustrated."
                                  }}
                                </p>
                                <figure>
                                  <if-async-image src="../assets/images/cards/cvvex.png"></if-async-image>
                                </figure>
                              </div>
                            </div>
                          </span>
                        </if-billing-form-input>

                        <div class="exp-date flex-space">
                          <p>{{ "Expiration" }}:</p>
                          <div class="form_group">
                            <if-billing-form-select
                              [form]="form"
                              name="expirationMonth"
                              placeholder="{{ 'Month' }}"
                              [required]="true"
                              error="{{ 'Select month'  }}"
                              [options]="form.creditCardMonthOptions">
                              <ng-template
                                #optionTemplate
                                let-month="option">{{
                                month.month + "-" + month.name
                                }}
                              </ng-template>
                            </if-billing-form-select>
                          </div>
                          <div class="form_group">
                            <if-billing-form-select
                              [form]="form"
                              name="expirationYear"
                              placeholder="{{ 'Year' }}"
                              [required]="true"
                              error="{{ 'Select year'}}"
                              [options]="form.creditCardYearsOptions">
                              <ng-template
                                #optionTemplate
                                let-year="option">{{
                                year
                                }}
                              </ng-template>
                            </if-billing-form-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div (click)="submit()" class="select-payment-btn">
                      Send
                    </div>
                  </div>
                </div>
              </ng-template>

              <ng-template #paypalTemplate let-submit="submit" let-back="back">
                <div id="overlay"></div>
                <div class="modal payment-modal">
                  <div class="modal-header">
                    <div (click)="back()" class="back">
                      <!-- back -->
                      <i class="material-icons">arrow_back</i>
                    </div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/paypal.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div (click)="submit()" class="button paypalBtn">
                    <!-- Pay with PAYPAL -->
                    <figure>
                      <if-async-image
                        src="../../assets/images/paypal.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                </div>
              </ng-template>

              <ng-template #klarnaTemplate let-back="back" let-submit="submit">
                <div id="overlay"></div>
                <div class="modal payment-modal">
                  <div class="modal-header">
                    <div (click)="back()" class="back">
                      <!-- back -->
                      <i class="material-icons">arrow_back</i>
                    </div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/klarna.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div (click)="submit()" class="button klarnaBtn">
                    <!-- Pay with KLARNA -->
                    <figure>
                      <if-async-image
                        src="../../assets/images/klarna.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                </div>
              </ng-template>

              <ng-template #idealTemplate let-banks="banks" let-back="back" let-setIssuer="setIssuer">
                <div id="overlay"></div>
                <div class="modal payment-modal ideal-modal">
                  <div class="modal-header">
                    <div (click)="back()" class="back">
                      <!-- back -->
                      <i class="material-icons">arrow_back</i>
                    </div>
                    <figure>
                      <if-async-image
                        src="../../assets/images/ideal.svg"
                      ></if-async-image>
                    </figure>
                  </div>
                  <div *ngFor="let bank of banks" (click)="setIssuer(bank)">
                    <div class="ideal-bank">
                      <figure>
                        <if-async-image
                          src="../../assets/images/banks/{{ bank }}.svg"
                        ></if-async-image>
                      </figure>
                      <p class="bank-name">{{ bank }}</p>
                    </div>
                  </div>
                </div>
              </ng-template>


			 <ng-template #creditCardTemplate>
			 	<div>
			     <div class="form">
	               <div id="payment-form">
	                <div class="if-billing-form">
	                  <if-billing-form-input
	                    class="cc-input"
	                    [form]="form"
	                    type="text"
	                    [maxlength]="16"
	                    [minlength]="14"
	                    name="cardNumber"
	                    error="{{
	                      'Please, enter valid card number'
	                        | trans: 'cardNumberError'
	                    }}"
	                    [required]="true"
	                    label="{{ 'Credit card number' | trans: 'cardNumber' }}"
	                  >
	                    <i class="material-icons" prefix>lock</i>
	                    <div
	                      class="cc-image {{ form.creditCardType }}"
	                      [ngStyle]="{
	                        'background-image':
	                          'url(assets/images/cards/card-' +
	                          (form.creditCardType || 'blank') +
	                          '.jpg)'
	                      }"
	                      postfix
	                    ></div>
	                  </if-billing-form-input>
	                  <if-billing-form-input
	                    [form]="form"
	                    type="text"
	                    [maxlength]="4"
	                    name="cvvCode"
	                    [required]="true"
	                    autocomplete="off"
	                    label="{{ 'CVV code' | trans: 'cvvCode' }}"
	                    error="{{
	                      'Please, enter a valid cvv code' | trans: 'cvvCodeError'
	                    }}"
	                  >
	                    <span class="cvv-info" postfix>
	                      <span class="cvv-icon">?</span>
	                      <div class="cvv-exp">
	                        <div class="container">
	                          <p>
	                            {{
	                              "The security code is a three digit number, located on the back of any Visa ® or MasterCard ® on the right side of the signature strip as illustrated."
	                                | trans: "cvvInfo"
	                            }}
	                          </p>
	                          <figure>
	                            <if-async-image
	                              src="../assets/images/cards/cvvex.png"
	                            ></if-async-image>
	                          </figure>
	                        </div>
	                      </div>
	                    </span>
	                  </if-billing-form-input>
	
	                  <div class="exp-date flex-space">
	                    <p>{{ "Expiration" | trans: "expiration" }}:</p>
	                    <div class="form_group">
	                      <if-billing-form-select
	                        [form]="form"
	                        name="expirationMonth"
	                        placeholder="{{ 'Month' | trans: 'expMonth' }}"
	                        [required]="true"
	                        error="{{ 'Select month' | trans: 'expMonthError' }}"
	                        [options]="form.creditCardMonthOptions"
	                      >
	                        <ng-template #optionTemplate let-month="option">{{
	                          month.month + "-" + month.name
	                        }}</ng-template>
	                      </if-billing-form-select>
	                    </div>
	                    <div class="form_group">
	                      <if-billing-form-select
	                        [form]="form"
	                        name="expirationYear"
	                        placeholder="{{ 'Year' | trans: 'expYear' }}"
	                        [required]="true"
	                        error="{{ 'Select year' | trans: 'expYearError' }}"
	                        [options]="form.creditCardYearsOptions"
	                      >
	                        <ng-template #optionTemplate let-year="option">{{
	                          year
	                        }}</ng-template>
	                      </if-billing-form-select>
	                    </div>
	                  </div>
	                </div>
	              </div>
			    </div>
			   </div>
			 		  
				<div>
				  <button
	                type="submit"
	                class="button button-checkout"
	                (click)="form.billingForm.ngSubmit.emit()"
	              >
	                {{ "Yes, Send mine now!" | trans: "buttonSend" }}
	              </button>
	            </div>
			            
			 </ng-template>
            </if-select-payment-method>
		</div>

          <div class="icons_wrap hide-desktop">
            <div class="support-icon">
              <figure class="icon">
                <if-async-image src="../../assets/images/icon-shipping.png"></if-async-image>
              </figure>
              <p>{{"Fast shipping with tracking" | trans: "supportShipping"}}</p>
            </div>
            <div class="support-icon">
              <figure class="icon">
                <if-async-image src="../../assets/images/icon-payment.png"></if-async-image>
              </figure>
              <p>{{"Safe and flexible payments" | trans: "supportPayment"}}</p>
            </div>
            <div class="support-icon">
              <figure class="icon">
                <if-async-image src="../../assets/images/icon-support.png"></if-async-image>
              </figure>
              <p>{{"Dedicated support" | trans: "supportSupport"}}</p>
            </div>
          </div>

          <div class="trust-icons">
            <p>
              {{"Guaranteed" | trans: "guaranteeSafe1"}}
              <span>{{"safe" | trans: "guaranteeSafe2"}}</span>
              {{"checkout" | trans: "guaranteeSafe3"}}
            </p>
            <figure class="logos">
              <if-async-image src="../../assets/images/trust-icons2.svg">
                <ng-template #imagePlaceholder>
                  <div></div>
                </ng-template>
              </if-async-image>
            </figure>
          </div>
          <div class="money-back">
            <figure>
              <if-async-image
                src="../../assets/images/money-back.png"
              ></if-async-image>
            </figure>
            <p>
              <span>{{"30 day guarantee" | trans: "guarantee30"}}:</span>
              &nbsp;
              {{"We offers a 30 day guarantee on all unused purchases. Simply send the item(s) back to us in the original unopened packaging for a full refund or replacement, less S&amp;H."
                  | trans: "guarantee30text"}}
            </p>
          </div>

          <figure class="col-banner">
            <if-async-image
              *ngIf="form.getImageSrcByName('bottom-banner')"
              [src]="form.getImageSrcByName('bottom-banner')"
            ></if-async-image>
          </figure>
        </div>

        <div class="col hide-mobile">
          <div class="sticky">
            <div class="sum_wrap">
              <div class="sum-header">
                <h5 class="title">{{"Order summary" | trans: "summaryTitle"}}</h5>
              </div>
              <div class="order-item">
                <figure class="prod-image"><if-async-image [src]="form.getImageSrcByName('product-image')"></if-async-image></figure>
                <div class="sum-text">
                  <div class="text">
                    <h6 class="productName">{{form.selectedPackageTitle}}</h6>
                    <h6 class="edit-link" (click)="scroll(targetEdit)">{{"Edit" | trans: "edit"}}</h6>
                  </div>
                  <div class="sum-price">
                    <h6 class="sum-qty">{{"QTY" | trans: "qty"}}: <span class="amount">{{ form.selectedPackageCountry.packageData.units }}</span></h6>
                    <h6 class="sum-price">{{form.currency}}{{form.cartPrice}}</h6>
                  </div>
                </div>
              </div>
              <ul class="order-list">
                <li class="order-list-item">
                  <span class="list-desc">{{"Subtotal" | trans: "subTotal"}}</span>
                  <span class="list-price">{{form.currency}}{{form.cartPrice}}</span>
                </li>
                <li class="order-list-item">
                  <span class="list-desc">{{"Discount" | trans: "discount"}}</span>
                  <span class="list-price discount-text">-{{form.currency}}{{form.discount}}</span>
                </li>
                <li class="order-list-item" *ngIf="form.variantsAdditionalPrice && form.variantsAdditionalPrice != 0 ">
                  <span class="list-desc">{{"Additional cost" | trans: "additionalCost"}}</span>
                  <span class="list-price">{{form.currency}}{{form.variantsAdditionalPrice}}</span>
                </li>
                <li class="order-list-item" *ngIf="form.bumpCheckbox">
                  <span class="list-desc">{{ form.selectedPackageCountry.bumpPackageCountry.packageData.units}} {{ form.selectedPackageCountry.bumpPackageCountry.packageData.productName }}</span>
                  <span class="list-price">{{ form.currency }}{{ form.selectedPackageCountry.bumpPackageCountry.price }}</span>
              	</li>
                <li class="order-list-item" *ngIf="form.formGroup.value.warranty">
                  <span class="list-desc">{{"Lifetime Protection" | trans: "warrantyLine"}}</span>
                  <span class="list-price">{{form.currency}}{{form.warrantyPrice}}</span>
                </li>
                <li class="order-list-item mark">
                  <span class="list-desc">{{"Shipping" | trans: "shipping"}}</span>
                  <span class="list-price">{{form.currency}}{{form.shippingPrice}}</span>
                </li>
                <li class="order-list-item">
                  <span class="list-desc">{{"Total" | trans: "total"}}</span>
                  <span class="list-price">{{form.currency}}{{form.totalPrice}}</span>
                </li>
              </ul>
            </div>
            <div class="icons_wrap">
              <div class="support-icon">
                <figure class="icon">
                  <if-async-image src="../../assets/images/icon-shipping.png"></if-async-image>
                </figure>
                <p>{{"Fast shipping with tracking" | trans: "supportShipping"}}</p>
              </div>
              <div class="support-icon">
                <figure class="icon">
                  <if-async-image src="../../assets/images/icon-payment.png"></if-async-image>
                </figure>
                <p>{{"Safe and flexible payments" | trans: "supportPayment"}}</p>
              </div>
              <div class="support-icon">
                <figure class="icon">
                  <if-async-image src="../../assets/images/icon-support.png"></if-async-image>
                </figure>
                <p>{{"Dedicated support" | trans: "supportSupport"}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="button_wrap button_fixed {{ showOrderButton ? 'show' : '' }}">
      <button type="button" class="button">
        <span (click)="scroll(targetForm)">
          {{"Order now" | trans: "orderBtn"}}
        </span>
      </button>
    </div>

    <!-- on success order -->
    <ng-template #orderSuccessDialogTemplate let-response="response">
      <div id="overlay"></div>
      <div class="modal">
        <span class="close-modal"></span>
        <div class="container">
          <h3 class="discount-title">
            {{"Congratulations!" | trans: "congratulations"}}
          </h3>
          <div class="discount-text">
            <h5>{{"Your order is on the way" | trans: "orderSended"}}</h5>
            <h5>{{"Order Id" | trans: "orderId"}}: {{response.orderId}}</h5>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- loader -->
    <ng-template #loaderTemplate>
      <div id="overlay"></div>
      <div class="modal process_wrap">
        <div class="container">
          <div class="title">
            <h4 class="text-primary">
              {{"Thank you for your purchase!" | trans: "thankYou"}}
            </h4>
            <h5>
              {{"Your order is being processed" | trans: "orderProcessed"}}
            </h5>
            <h5>
              {{"Do not refresh or close your browser" | trans: "notRefresh"}}
            </h5>
          </div>

          <div class="process-steps">
            <if-page-view [millisecondInterval]="4000">
              <if-page-view-slide>
                <span class="check"></span>
                <h5>
                  {{
                    "Connecting to credit card processors"
                      | trans: "processStep1"
                 }}
                </h5>
                <span class="step-bar"></span>
              </if-page-view-slide>
              <if-page-view-slide>
                <span class="check"></span>
                <h5>
                  {{
                    "Verifying Your Payment Information" | trans: "processStep2"
                 }}
                </h5>
                <span class="step-bar"></span>
              </if-page-view-slide>
              <if-page-view-slide>
                <span class="check"></span>
                <h5>
                  {{
                    "Your Transaction is being Processed"
                      | trans: "processStep3"
                 }}
                </h5>
                <span class="step-bar"></span>
              </if-page-view-slide>
            </if-page-view>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- error -->
    <ng-template #orderFailedDialogTemplate let-close="close" let-error="error">
      <div id="overlay"></div>
      <div class="modal error process-failed">
        <span class="close-modal" (click)="close()"></span>
        <div class="container">
          <h5 class="discount-title">
            {{error.message | trans: 'orderErrorMessage' || "{{'Your transaction had been declined' | trans: 'transactionDeclined'}}"}}
          </h5>
          <h5>{{error.description || ""}}</h5>
          <p>
            {{"For any additional information" | trans: "anyInformation"}}<br>
            {{"Contact our" | trans: "contactOur"}}
            <a class="text-primary" href="{{form.supportLink}}">{{"support" | trans: "support"}}</a
            ><br>
            {{"Or email us" | trans: "emailUs"}}:
            <a class="text-primary" href="mailto:{{form.supportEmail}}">{{form.supportEmail}}</a>
          </p>
          <button type="button" class="button" (click)="close()">OK</button>
        </div>
      </div>
    </ng-template>

    <!-- on user leave screen dialog -->
    <if-exit-dialog ifQueryControl="ep">
      <ng-template #dialogTemplate let-close="close">
        <div id="overlay" (click)="close()"></div>
        <div class="discount10 modal">
          <span class="close-modal" (click)="close()"></span>
          <div class="container">
            <h3 class="discount-title">{{"Winner" | trans: "winner"}}!</h3>
            <div class="discount-text">
              <h5>
                {{form.currency}}{{"10 OFF next purchase" | trans: "discount10text"}}
              </h5>
            </div>
            <div class="buttons_wrap">
              <button type="button" (click)="showLine = true; close()">
                <span>
                  <if-translation transKey="yesButton">
                      I want  {{form.currency}}10 Off Now!
                  </if-translation>
                </span>
              </button>
              <button type="button" class="button-deny" (click)="close()">
                <span>
                  <if-translation transKey="noButton">
                      No, I Don't Want this Great Deal
                  </if-translation>
                </span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </if-exit-dialog>


    <!--Purchase notification-->
    <if-purchase-notifications class="recent_wrap" [form]="form" [initialSecondDelayRange]="[1, 1]" [intervalSecondRange]="[10, 15]" [displaySecondDuration]="5" ifQueryControl="nt">
      <ng-template #notificationTemplate let-note="notification">
        <div id="recentBox">
          <figure id="recentImg">
            <if-async-image [src]="form.getImageSrcByName('product-image')" ></if-async-image>
          </figure>
          <div id="recentText">
            <div class="text">
              <span id="randFirst">{{note.firstName}}</span>
              <span id="randLast"> {{note.letter}}</span
              >. {{"from" | trans: "notificationFrom"}}
              <span id="randLocation">{{note.city}}</span>
              <br>
              {{"just purchased" | trans: "notificationPurchase"}}
              <span class="prodTitle">{{form.product.productData.title}}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </if-purchase-notifications>

    <section class="sec-testimonials" ifQueryControl="cm">
       <div class="container">
        <if-testimonials [form]="form" dateFormat="dd/MM/yyyy">
          <ng-template #testimonialTemplate let-testimonial="testimonial">
            <div class="user">
              <figure>
                <if-async-image src="{{testimonial.image}}"></if-async-image>
              </figure>
              <div class="user-info">
                <p>
                  {{testimonial.author}}
                  <span>{{testimonial.place}}</span>
                </p>
              </div>
            </div>
            <p>
              {{testimonial.testimonial}}
            </p>
            <div class="comment-footer">
              <span class="like">{{"Like" | trans: "like"}}</span>
              <span class="reply">{{"Reply" | trans: "reply"}}</span>
              <span>12</span>
              <span class="date">{{testimonial.date}}</span>
            </div>
          </ng-template>
        </if-testimonials>
      </div>
    </section>

    <section class="faq_wrap">
      <div class="faq-title" (click)="toggleDisplayFaq()">
        <p>
          {{"Have a question" | trans: "faqTitle1"}}?<span>{{
            "See our FAQs" | trans: "faqTitle2"
         }}</span>
        </p>
      </div>
      <div id="faq" [hidden]="isShowFaq">
        <if-product-faq [form]="form">
          <div class="product-placeholder" loader></div>
        </if-product-faq>
      </div>
    </section>

    <footer>
      <div class="container">
        <p class="footer-details no-select">
          © <span>{{currentyear | date: "yyyy"}}</span> -
          {{form.companyDetails.companyName}}
        </p>
        <ul class="links_wrap">
          <li [ifPopupButton]="terms">
            {{"Terms &amp; Conditions" | trans: "terms"}}
          </li>
          <li [ifPopupButton]="privacy">
            {{"Privacy policy" | trans: "privacy"}}
          </li>
          <li
            [ifPopupButton]="ccpa"
            [hidden]="
              !form.formGroup.get('country')?.value ||
              form.formGroup.get('country')?.value?.code2 != 'US'
            "
          >
            CCPA
          </li>
          <li
            [ifPopupButton]="impressum"
            [hidden]="
              !form.formGroup.get('country')?.value ||
              form.formGroup.get('country')?.value?.code2 != 'DE'
            "
          >
            Impressum
          </li>
          <li>
            <a href="https://konelix.com/" target="_black">{{
              "Affiliates" | trans: "affiliates"
           }}</a>
          </li>
        </ul>
        <ul class="footer-details company-details no-select">
          <li>{{form.companyDetails.supportNumber}}</li>
          <li>{{form.companyDetails.supportEmail}}</li>
          <li>{{form.companyDetails.companyAddress}}</li>
        </ul>
      </div>
      <div class="badge">
        <a
          href="https://www.dmca.com/Protection/Status.aspx?ID=aa6604d1-1880-4110-a1a8-75579910d347&amp;refurl=https://checkout.thetrendzoo.com/billing/billing1/index.html?camp=5082&amp;theme=properfocus1&amp;clickid=GiCL5EnAmGnAngGuiKeQXnW244E5QR9J1qX6ZT_PJH4hCiCRxVE&amp;pub=Taboola~nbcuniversal-msnbc&amp;extra=Optix_US_Dsk_RON_14.10&amp;sub_pub_id=1012083&amp;rd=co&amp;tblci=GiCL5EnAmGnAngGuiKeQXnW244E5QR9J1qX6ZT_PJH4hCiCRxVE&amp;country=US&amp;hash=hbHwUjpHE78P9Z+oz0QPwMTbgE0kKOWYpXXRT3Mru/2qMH4Zm9v6FYe2AaN3UF1dchncQHkljXr0wq6x1MzxQtrHqWy+zoI9zeTtwwUPPXvGHayMZFL1MQsVWqRQ1mQETZuxEed4jjDVXJYMs3JnlFHvpBmZiwSMV2kppPW1tr0dYYuvRY1CQ81g0rL39Jp1aMO+ROf3V5IzrOeieT++ZZzV+XyDxo8m/1XxfsJnhkc=&amp;productNum=5730499526813"
          title="DMCA.com Protection Status"
          class="dmca-badge"
          target="_blank"
        >
          <if-async-image
            src="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=aa6604d1-1880-4110-a1a8-75579910d347"
            alt="DMCA.com Protection Status"
          ></if-async-image>
        </a>
        <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"></script>
      </div>
    </footer>

    <div class="legal_wrap">
      <ng-template #terms let-close="close">
        <div id="overlay" (click)="close()"></div>
        <div class="privacy-modal">
          <span class="close-modal" (click)="close()"></span>
          <app-terms [form]="form"></app-terms>
        </div>
      </ng-template>
      <ng-template #privacy let-close="close">
        <div id="overlay" (click)="close()"></div>
        <div class="privacy-modal">
          <span class="close-modal" (click)="close()"></span>
          <app-privacy [form]="form"></app-privacy>
        </div>
      </ng-template>
      <ng-template #ccpa let-close="close">
        <div id="overlay" (click)="close()"></div>
        <div class="privacy-modal">
          <span class="close-modal" (click)="close()"></span>
          <app-ccpa [form]="form"></app-ccpa>
        </div>
      </ng-template>
      <ng-template #impressum let-close="close">
        <div id="overlay" (click)="close()"></div>
        <div class="privacy-modal impressum-modal">
          <span class="close-modal" (click)="close()"></span>
          <app-impressum [form]="form"></app-impressum>
        </div>
      </ng-template>
    </div>
  </div>
</if-billing-form>
